import { render, staticRenderFns } from "./PartnerManagement.vue?vue&type=template&id=258e3410&scoped=true&"
import script from "./PartnerManagement.vue?vue&type=script&lang=ts&"
export * from "./PartnerManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerManagement.vue?vue&type=style&index=0&id=258e3410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e3410",
  null
  
)

export default component.exports